import { render, staticRenderFns } from "./vc-button.vue?vue&type=template&id=57f5e8ee&scoped=true&"
import script from "./vc-button.vue?vue&type=script&lang=js&"
export * from "./vc-button.vue?vue&type=script&lang=js&"
import style0 from "./vc-button.vue?vue&type=style&index=0&id=57f5e8ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f5e8ee",
  null
  
)

export default component.exports